import { useMutation, useQueryClient } from "@tanstack/react-query";
import BankMpProvider from "@/core/data-provider/data-mp/bank/bank-mp-provider";
import { RpcMpProviderFailedResponse } from "@/core/rpc-mp-provider/responses/rpc-mp-provider-failed-response";
import { QUERY_KEY_BANK_CHARACTER } from "@/domains/bank/hooks/useBankCharacterQuery";

export function useCreateBankAccountMutation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (tariffId: number) => {
      const response = await BankMpProvider.createBankAccount(tariffId);

      if (response instanceof RpcMpProviderFailedResponse) {
        throw new Error(response.error?.message);
      }

      return response.data;
    },

    onSuccess: () => {
      return queryClient.invalidateQueries({ queryKey: [QUERY_KEY_BANK_CHARACTER] });
    },
  });
}
